var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settings" },
    [
      _c("settings-slider", {
        attrs: {
          label: _vm.resource("TemplateDefaultSettings_BlockWidth_Label"),
          min: 250,
          max: 900,
          "value-suffix": "px"
        },
        model: {
          value: _vm.model.blockWidth,
          callback: function($$v) {
            _vm.$set(_vm.model, "blockWidth", $$v)
          },
          expression: "model.blockWidth"
        }
      }),
      _vm._v(" "),
      _c("settings-slider", {
        attrs: {
          label: _vm.resource("TemplateDefaultSettings_BlockPadding_Label"),
          "value-suffix": "px"
        },
        model: {
          value: _vm.model.blockPadding,
          callback: function($$v) {
            _vm.$set(_vm.model, "blockPadding", $$v)
          },
          expression: "model.blockPadding"
        }
      }),
      _vm._v(" "),
      _c("settings-dropdown", {
        attrs: {
          label: _vm.resource("TemplateDefaultSettings_HeadingSize_Label"),
          options: _vm.headingSizes
        },
        model: {
          value: _vm.model.headingSize,
          callback: function($$v) {
            _vm.$set(_vm.model, "headingSize", $$v)
          },
          expression: "model.headingSize"
        }
      }),
      _vm._v(" "),
      _c("settings-dropdown", {
        attrs: {
          label: _vm.resource("TemplateDefaultSettings_Font_Label"),
          options: _vm.fonts,
          "value-field": "value",
          "text-field": "text"
        },
        model: {
          value: _vm.model.font,
          callback: function($$v) {
            _vm.$set(_vm.model, "font", $$v)
          },
          expression: "model.font"
        }
      }),
      _vm._v(" "),
      _c("settings-dropdown", {
        attrs: {
          label: _vm.resource("TemplateDefaultSettings_FontSize_Label"),
          options: _vm.fontSizes,
          "value-field": "value",
          "text-field": "text"
        },
        model: {
          value: _vm.model.fontSize,
          callback: function($$v) {
            _vm.$set(_vm.model, "fontSize", $$v)
          },
          expression: "model.fontSize"
        }
      }),
      _vm._v(" "),
      _c("settings-color-picker", {
        attrs: {
          label: _vm.resource("TemplateDefaultSettings_TextColor_Label")
        },
        model: {
          value: _vm.model.textColor,
          callback: function($$v) {
            _vm.$set(_vm.model, "textColor", $$v)
          },
          expression: "model.textColor"
        }
      }),
      _vm._v(" "),
      _c("settings-toggle", {
        attrs: {
          label: _vm.resource("TemplateDefaultSettings_BoldText_Label")
        },
        model: {
          value: _vm.model.boldText,
          callback: function($$v) {
            _vm.$set(_vm.model, "boldText", $$v)
          },
          expression: "model.boldText"
        }
      }),
      _vm._v(" "),
      _c("settings-toggle", {
        attrs: {
          label: _vm.resource("TemplateDefaultSettings_ItalicText_Label")
        },
        model: {
          value: _vm.model.italicText,
          callback: function($$v) {
            _vm.$set(_vm.model, "italicText", $$v)
          },
          expression: "model.italicText"
        }
      }),
      _vm._v(" "),
      _c("settings-radio", {
        attrs: {
          options: _vm.textAlignmentOptions,
          label: _vm.resource("TemplateDefaultSettings_TextAlignment_Label"),
          "value-field": "value",
          "text-field": "text"
        },
        model: {
          value: _vm.model.textAlignment,
          callback: function($$v) {
            _vm.$set(_vm.model, "textAlignment", $$v)
          },
          expression: "model.textAlignment"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }